import React, {useEffect} from 'react';

import AppImage01 from '../../../../images/applications-image-01.jpg';

function PageCard({pageData, viewDetail}) {

  const market_emojis = {
    'Art & Design': '🎨',
    'Auto & Vehicles':'🚗',
    'Beauty':'💄',
    'Books & Reference':'📚',
    'Business':'💼',
    'Comics':'🦸',
    'Communication':'💬',
    'Dating':'💖',
    'Education':'🎓',
    'Entertainment':'📺',
    'Events':'🎟️',
    'Finance':'💸',
    'Food & Drink':'🧋',
    'Health & Fitness':'🏋️',
    'House & Home':'🏠',
    'Libraries & Demo':'📖',
    'Lifestyle':'🕺',
    'Maps & Navigation':'🗺️',
    'Medical':'🩺',
    'Music & Audio':'🎵',
    'News & Magazines':'📰',
    'Parenting':'🍼',
    'Personalization':'🖳',
    'Photography':'📸',
    'Productivity':'🔨',
    'Shopping':'🛒',
    'Social':'🍺',
    'Sports':'⚽',
    'Tools':'⚙️',
    'Watch Faces': '⌚',
    'Watch Apps': '⌚',
    'Travel & Local':'✈️',
    'Video Players & Editors':'📹',
    'Weather':'🌤️',
    'Games & Audio': '🕹️',
    'Games': '🕹️'
  }

  const tone_emojis = {
    'admiration': '😍',
    'amusement': '😂',
    'anger': '😠',
    'annoyance': '😒',
    'approval': '😌',
    'caring': '🤗',
    'confusion': '🧐',
    'curiosity': '🤔',
    'desire': '🤤',
    'disappointment': '😔',
    'disapproval': '🙄',
    'disgust': '🤮',
    'embarrassment': '😳',
    'excitement': '🥳',
    'fear': '😨',
    'gratitude': '😅',
    'grief': '😭',
    'joy': '😁',
    'love': '🥰',
    'nervousness': '😟',
    'optimism': '😄',
    'pride': '😏',
    'realization': '😯',
    'relief': '😮‍💨',
    'remorse': '🥺',
    'sadness': '😢',
    'surprise': '😮',
    'neutral': '😐'
  }

  const topic_emojis = {
    'arts & culture': '🎭',
    'world': '🌎',
    'news': '📰',
    'sports': '⚽',
    'healthy living': '🏋️',
    'education': '🎓',
    'home & living': '🏠',
    'media': '📺',
    'technology & science': '🚀',
    'crime': '🕵️',
    'travel': '✈️',
    'environment': '🌳',
    'style & beauty': '👗',
    'food & drink': '🥤',
    'religion': '🛐',
    'money': '💸',
    'business': '💼',
    'parenting': '🍼',
    'entertainment': '🎞️',
    'politics': '🗳️',
    'comedy': '🤣',
    'wellness': '🏃'
  }

  useEffect(() => {}, [pageData]);

  return (
      <React.Fragment>
        {/* Card 1 */}
        <div className="col-span-full sm:col-span-6 xl:col-span-3 bg-white shadow-1 rounded-sm
         border border-slate-200 overflow-hidden">
          <div className="flex flex-col h-full">
            {/* Image */}
            <div className="w-full h-72 overflow-hidden justify-center">
              <iframe className="frame-scaled" src={pageData.hasOwnProperty("url")?pageData.url.replace("http://", "https://"):""}></iframe>
            </div>
            {/* Card Content */}
            {/*<div className="grow flex flex-col p-5">
               Card body
              <div className="grow">
                 Header
                <header className="mb-3">
                  <h3 className="text-lg text-slate-800 font-semibold">pageData.subject</h3>
                </header>
                 Features list
                <ul className="text-sm space-y-2 mb-5">
                  <li className="flex items-center">
                    <p className="fill-current text-slate-400 mr-3">
                      {pageData.source==='WEB_PAGE'?'🌐':'🛬'}
                    </p>
                    <div>{pageData.source}</div>
                  </li>
                  <li className="flex items-center">
                    <p className="fill-current text-slate-400 mr-3">
                      {market_emojis[pageData.type]}
                    </p>
                    <div>Suitable for <i>{pageData.type}</i> vertical</div>
                  </li>
                  <li className="flex items-center">
                    <p className="fill-current text-slate-400 mr-3">
                      tone_emoji
                    </p>
                    <div>Written with <i>tone</i> tone</div>
                  </li>
                  <li className="flex items-center">
                    <p className="fill-current text-slate-400 mr-3">
                     topic emoji
                    </p>
                    <div>Content theme is <i>topic</i></div>
                  </li>
                </ul>
              </div>
               Card footer
              <div className="cursor-pointer" >
                <a className="btn-sm w-full bg-pink-400 hover:bg-pink-600 text-white">Check it out</a>
              </div>
            </div>*/}
          </div>
        </div>
      </React.Fragment>
  );
}

export default PageCard;